import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { FixedSizeList } from 'react-window';
import CartItemRow from './CartItemRow';

const CartProductList = ({ cart, removedItemId, updateCartItemQuantity, handleRemoveItem, getDiscountedPrice, formatImageUrl }) => {
  const useVirtualization = cart.length > 10;
  return useVirtualization ? (
    <FixedSizeList height={600} itemCount={cart.length} itemSize={240} width="100%">
      {({ index, style }) => (
        <CartItemRow
          index={index}
          style={style}
          cart={cart}
          removedItemId={removedItemId}
          updateCartItemQuantity={updateCartItemQuantity}
          handleRemoveItem={handleRemoveItem}
          getDiscountedPrice={getDiscountedPrice}
          formatImageUrl={formatImageUrl}
        />
      )}
    </FixedSizeList>
  ) : (
    <AnimatePresence>
      {cart.map((_, index) => (
        <CartItemRow
          key={cart[index].id}
          index={index}
          cart={cart}
          style={{}}
          removedItemId={removedItemId}
          updateCartItemQuantity={updateCartItemQuantity}
          handleRemoveItem={handleRemoveItem}
          getDiscountedPrice={getDiscountedPrice}
          formatImageUrl={formatImageUrl}
        />
      ))}
    </AnimatePresence>
  );
};

export default CartProductList;
